import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Checkbox } from 'primereact/checkbox';
import { getSubtypeHeader } from '../../../utils/subTypeHeader';

export default function FoodForm({ shopType, formState, setFormState }) {
  const subtype = shopType;
  const headerText = getSubtypeHeader(subtype);

  const handleCheckboxChange = (key, value) => {
    setFormState(key, value);
  };

  return (
    <div className="form-section">
      <h3 className="section-title">{headerText}</h3>

      {/* Shared fields */}
      <div className="field">
        <label>Cuisine subtype</label>
        <InputText
          value={formState[`cuisinesubtype_${subtype}`] || ''}
          onChange={(e) => setFormState(`cuisinesubtype_${subtype}`, e.target.value)}
          placeholder="e.g. Italian, Filipino, Japanese"
        />
      </div>

      <div className="field">
        <label>Menu URL</label>
        <InputText
          value={formState[`menuUrl_${subtype}`] || ''}
          onChange={(e) => setFormState(`menuUrl_${subtype}`, e.target.value)}
          placeholder="https://example.com/menu"
        />
      </div>

      {/* Specific to Restaurant & Café */}
      {subtype === 'FB_restaurant' && (
        <>
          <div className="field">
            <label>Seating Capacity</label>
            <InputText
              value={formState[`seatingCapacity_${subtype}`] || ''}
              onChange={(e) => setFormState(`seatingCapacity_${subtype}`, e.target.value)}
              placeholder="e.g. 30"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`acceptsReservations_${subtype}`}
                checked={formState[`acceptsReservations_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`acceptsReservations_${subtype}`, e.checked)}
              />
              <label htmlFor={`acceptsReservations_${subtype}`} className="ml-2">Accepts Reservations</label>
            </div>
          </div>
        </>
      )}

      {/* Specific to Bakery */}
      {subtype === 'FB_bakery' && (
        <>
          <div className="field">
            <label>Specialty Items</label>
            <InputText
              value={formState[`specialtyItems_${subtype}`] || ''}
              onChange={(e) => setFormState(`specialtyItems_${subtype}`, e.target.value)}
              placeholder="e.g. Custom cakes, Pandesal"
            />
          </div>
        </>
      )}

      {/* Specific to Catering */}
      {subtype === 'FB_catering' && (
        <>
          <div className="field">
            <label>Event subtypes Served</label>
            <InputText
              value={formState[`eventsubtypes_${subtype}`] || ''}
              onChange={(e) => setFormState(`eventsubtypes_${subtype}`, e.target.value)}
              placeholder="e.g. Weddings, Birthdays, Corporate"
            />
          </div>

          <div className="field">
            <label>Minimum Pax</label>
            <InputText
              value={formState[`minPax_${subtype}`] || ''}
              onChange={(e) => setFormState(`minPax_${subtype}`, e.target.value)}
              placeholder="e.g. 20"
            />
          </div>
        </>
      )}

      {/* Specific to Food Truck */}
      {subtype === 'FB_foodTruck' && (
        <>
          <div className="field">
            <label>Service Locations</label>
            <InputText
              value={formState[`serviceLocations_${subtype}`] || ''}
              onChange={(e) => setFormState(`serviceLocations_${subtype}`, e.target.value)}
              placeholder="e.g. Fairs, Events, Business Districts"
            />
          </div>
        </>
      )}

      {/* Specific to Bar / Pub */}
      {subtype === 'FB_bar' && (
        <>
          <div className="field">
            <label>Happy Hour Schedule</label>
            <InputText
              value={formState[`happyHour_${subtype}`] || ''}
              onChange={(e) => setFormState(`happyHour_${subtype}`, e.target.value)}
              placeholder="e.g. 5pm - 8pm"
            />
          </div>

          <div className="field">
            <div className="flex align-items-center">
              <Checkbox
                inputId={`liveMusic_${subtype}`}
                checked={formState[`liveMusic_${subtype}`] || false}
                onChange={(e) => handleCheckboxChange(`liveMusic_${subtype}`, e.checked)}
              />
              <label htmlFor={`liveMusic_${subtype}`} className="ml-2">Offers Live Music</label>
            </div>
          </div>
        </>
      )}

      {/* Shared options */}
      <div className="field">
        <div className="flex align-items-center">
          <Checkbox
            inputId={`hasTakeout_${subtype}`}
            checked={formState[`hasTakeout_${subtype}`] || false}
            onChange={(e) => handleCheckboxChange(`hasTakeout_${subtype}`, e.checked)}
          />
          <label htmlFor={`hasTakeout_${subtype}`} className="ml-2">Offers Takeout</label>
        </div>
      </div>

      <div className="field">
        <div className="flex align-items-center">
          <Checkbox
            inputId={`hasDelivery_${subtype}`}
            checked={formState[`hasDelivery_${subtype}`] || false}
            onChange={(e) => handleCheckboxChange(`hasDelivery_${subtype}`, e.checked)}
          />
          <label htmlFor={`hasDelivery_${subtype}`} className="ml-2">Offers Delivery</label>
        </div>
      </div>
    </div>
  );
}
